"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _joditReact = _interopRequireDefault(require("jodit-react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useRichTextContent = _interopRequireDefault(require("./useRichTextContent"));

var _useDynamicFields = require("./useDynamicFields");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CONFIG_READ_ONLY = {
  toolbar: false,
  readonly: true,
  showCharsCounter: false,
  showWordsCounter: false,
  enter: 'br',
  showXPathInStatusbar: false,
  inline: true,
  toolbarInlineForSelection: false,
  showPlaceholder: false
};
var useStyles = (0, _makeStyles.default)(() => ({
  container: {
    '& .jodit-workplace': {
      overflow: 'visible'
    },
    '& .jodit-wysiwyg': {
      '& p:first-child': {
        marginTop: 0
      }
    }
  }
}), {
  name: 'Mui-RTE-Renderer'
});

var Renderer = (_ref) => {
  var {
    content,
    dynamicFields = [],
    onClick = () => {}
  } = _ref;
  var richTextContent = (0, _useRichTextContent.default)(content);
  richTextContent = (0, _useDynamicFields.render)(richTextContent, dynamicFields);
  var [ref, setRef] = (0, _react.useState)();
  var classes = useStyles();
  (0, _react.useEffect)(() => {
    if (!ref) return;
    var anchors = ref.getElementsByTagName('a'); // forEach fails for some cases here
    // eslint-disable-next-line no-restricted-syntax

    var _loop = function _loop(anchor) {
      anchor.onclick = e => {
        e.preventDefault();
        onClick(anchor.href, anchor.target);
      }; // We need this because on IOS devices,
      // you would have to double click otherwise.
      // single click triggers the hover behaviour
      // window.open does not work in ontouchstart


      anchor.ontouchend = e => {
        e.preventDefault();
        onClick(anchor.href, anchor.target);
      };
    };

    for (var anchor of anchors) {
      _loop(anchor);
    }
  }, [ref, content]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: setRef,
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_joditReact.default, {
    value: richTextContent,
    config: CONFIG_READ_ONLY
  }));
};

Renderer.propTypes = {
  content: _propTypes.default.string,
  dynamicFields: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired
  })),
  onClick: _propTypes.default.func
};
var _default = Renderer;
exports.default = _default;